import { CloudServerOutlined } from '@ant-design/icons';
import { UserIcon } from 'assets/images/svg';
import {
	CartIcon,
	DownloadIcon,
	EverythingIcon,
	FloorplanIcon,
	HomeIcon,
	LockersIcon,
	SettingsIcon,
	SitesIcon
} from 'assets/images/svg/Menu';
import { lazy } from 'react';

// LAZY LOAD OF Public PAGES IN THE PLATFORM WITH THEIR OWN NAME OF CHUNK
const QrSignup = lazy(() => import('publicContainer/QrSignup'));
const Signin = lazy(() => import('publicContainer/Signin'));
const CreatePassword = lazy(() => import('publicContainer/CreatePassword'));
const ForgotPassword = lazy(() => import('publicContainer/ForgotPassword'));

const FourZeroFour = lazy(() => import('publicContainer/404'));
const FourZeroOne = lazy(() => import('publicContainer/401'));
const FiveHundred = lazy(() => import('publicContainer/500'));

// ?  LAZY LOAD OF PRIVATE PAGES IN THE PLATFORM WITH THEIR OWN NAME OF CHUNK
const DashboardChooser = lazy(() => import('publicContainer/DashboardChooser'));
const Home = lazy(() => import('mainDashboard/Home'));
const Everything = lazy(() => import('mainDashboard/Everything'));
const Sites = lazy(() => import('mainDashboard/Site'));
const FloorPlan = lazy(() => import('mainDashboard/FloorPlan'));
const Inventory = lazy(() => import('mainDashboard/Inventory'));
// const Organisation = lazy(() => import('mainDashboard/Organisations'));

const Settings = lazy(() => import('mainDashboard/Settings'));

//Locker Dashboard routes
const PeopleLocker = lazy(() => import('lockerDashboard/People'));
const HomeLocker = lazy(() => import('lockerDashboard/Home'));
const LockersLocker = lazy(() => import('lockerDashboard/Lockers'));
const SettingsLocker = lazy(() => import('lockerDashboard/Settings'));

export const PUBLIC_ROUTES = [
	{
		key: 'qrSignup',
		path: '/qrsignup',
		exact: false,
		component: QrSignup
	},
	{
		path: '',
		exact: true,
		component: Signin
	},
	{
		path: 'signin',
		component: Signin
	},
	{
		path: 'forgotpassword',
		component: ForgotPassword
	},

	{
		path: 'createPassword',
		component: CreatePassword
	},
	{
		path: '404',
		component: FourZeroFour
	},
	{
		path: '401',
		component: FourZeroOne
	},
	{
		path: '500',
		component: FiveHundred
	}
];

// ? Sidebar options for the main dashboard is now object containing the access and position of the sidebar
// ? The position is used to determine the position of the option in the sidebar menu
// ? 0 is for the Top Navigation Routes
// ? 1 is for the Bottom Navigation Routes
// ? The access is used to determine the access level of the user to view the option
// ? Setting sidebar to false would hide the option from the sidebar
export const MAIN_DASHBOARD_ROUTES = [
	{
		path: '', //? The path of the base dashboard route.
		component: Home,
		exact: true,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Home',
		leftIcon: <HomeIcon />,
		entityTypeID: 1,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Home',
			position: 0
		}
	},
	{
		path: 'everything',
		component: Everything,
		exact: true,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Everything',
		leftIcon: <EverythingIcon />, //? Set the icon react component here
		entityTypeID: 2,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Everything',
			position: 0
		}
	},
	{
		path: 'sites',
		component: Sites,
		exact: true,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Sites',
		leftIcon: <SitesIcon />, //? Set the icon react component here
		entityTypeID: 2,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Sites',
			position: 0
		}
	},
	{
		path: 'floorplan',
		component: FloorPlan,
		exact: true,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Floorplan',
		leftIcon: <FloorplanIcon />, //? Set the icon react component here
		entityTypeID: 2,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Floorplan',
			position: 0
		}
	},
	{
		path: 'settings',
		component: Settings,
		access: [201, 202, 101, 102, 103, 108, 109],
		name: 'Settings',
		leftIcon: <SettingsIcon />, //? Set the icon react component here
		entityTypeID: 10,
		sidebar: {
			access: [201, 202, 101, 102, 103, 108, 109],
			name: 'Settings',
			position: 0
		}
	},
	{
		path: 'inventory',
		component: Inventory,
		exact: true,
		access: [201, 203],
		name: 'Inventory',
		leftIcon: <CloudServerOutlined style={{ color: '#545454' }} />, //? Set the icon react component here
		entityTypeID: 13,
		developerOnly: true,
		sidebar: {
			access: [201, 203],
			name: 'Inventory',
			position: 0
		}
	},
	{
		path: 'buy-locks', // A unique key to identify the item
		name: 'Buy Locks',
		access: [],
		leftIcon: <CartIcon />,
		sidebar: {
			position: 1,
			name: 'Buy Locks'
		}
	},
	{
		path: 'download-app', // A unique key to identify the item
		name: 'Download App',
		access: [],
		leftIcon: <DownloadIcon />,
		sidebar: {
			position: 1,
			name: 'Download Zezamii Access'
		}
	}
];

export const LOCKER_DASHBOARD_ROUTES = [
	{
		path: '', //? The path of the base dashboard route.
		component: HomeLocker,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Home',
		leftIcon: <HomeIcon />,
		entityTypeID: 1,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Home',
			position: 0
		}
	},
	{
		path: 'lockers',
		component: LockersLocker,
		exact: true,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Lockers',
		leftIcon: <LockersIcon />, //? Set the icon react component here
		entityTypeID: 2,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Lockers',
			position: 0
		}
	},
	{
		path: 'people',
		component: PeopleLocker,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'People',
		leftIcon: <UserIcon width={16} height={16} />, //? Set the icon react component here
		entityTypeID: 2,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'People',
			position: 0
		}
	},
	{
		path: 'settings',
		component: SettingsLocker,
		access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
		name: 'Settings',
		leftIcon: <SettingsIcon />, //? Set the icon react component here
		entityTypeID: 2,
		sidebar: {
			access: [201, 202, 101, 102, 103, 104, 105, 2, 107, 108, 109],
			name: 'Settings',
			position: 0
		}
	},
	{
		path: 'download-app', // A unique key to identify the item
		name: 'Download App',
		access: [],
		leftIcon: <DownloadIcon />,
		sidebar: {
			position: 1,
			name: 'Download Zezamii Lockers'
		}
	}
];
// Import the layouts for the dashboards
const AccessDashboardLayout = lazy(() => import('mainDashboard/Layout/index'));
const LockerDashboardLayout = lazy(() => import('lockerDashboard/Layout/index'));

/**
 * @description Defines the routes for the dashboards, List all the dashboards here eg. Lockers, MainDashboard, etc.
 * @type {Array}
 * @property {string} key - The key of the route.
 * @property {string} path - The path of the route.
 * @property {React.Component} component - The component to render for the route.
 */
export const DASHBOARD_ROUTES = [
	{
		key: 'access',
		path: 'access',
		component: AccessDashboardLayout,
		routes: MAIN_DASHBOARD_ROUTES
	},
	{
		key: 'lockers',
		path: 'lockers',
		component: LockerDashboardLayout,
		routes: LOCKER_DASHBOARD_ROUTES
	},
	{
		key: 'dashboardChooser',
		path: 'dashboardChooser',
		component: DashboardChooser,
		routes: [] // No routes for the dashboard chooser
	}
];
